import { render, staticRenderFns } from "./editJournal.vue?vue&type=template&id=222d92fe&scoped=true&"
import script from "./editJournal.vue?vue&type=script&lang=js&"
export * from "./editJournal.vue?vue&type=script&lang=js&"
import style0 from "./editJournal.vue?vue&type=style&index=0&id=222d92fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222d92fe",
  null
  
)

export default component.exports